"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeleteSmtpTokenRequestStatus = exports.getResetSmtpTokenPasswordRequestStatus = exports.getCreateSmtpTokenRequestStatus = exports.getFetchSmtpTokensRequestStatus = exports.getSmtpTokens = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var getSmtpTokens = function getSmtpTokens(state) {
  return state.modules.marketing.email.entities.smtpTokens;
};

exports.getSmtpTokens = getSmtpTokens;
var getFetchSmtpTokensRequestStatus = (0, _getRequestStatus.default)(_actions.SmtpTokensActionTypes.FETCH_SMTP_TOKENS);
exports.getFetchSmtpTokensRequestStatus = getFetchSmtpTokensRequestStatus;
var getCreateSmtpTokenRequestStatus = (0, _getRequestStatus.default)(_actions.SmtpTokensActionTypes.CREATE_SMTP_TOKEN);
exports.getCreateSmtpTokenRequestStatus = getCreateSmtpTokenRequestStatus;
var getResetSmtpTokenPasswordRequestStatus = (0, _getRequestStatus.default)(_actions.SmtpTokensActionTypes.RESET_SMTP_TOKEN_PASSWORD);
exports.getResetSmtpTokenPasswordRequestStatus = getResetSmtpTokenPasswordRequestStatus;
var getDeleteSmtpTokenRequestStatus = (0, _getRequestStatus.default)(_actions.SmtpTokensActionTypes.DELETE_SMTP_TOKEN);
exports.getDeleteSmtpTokenRequestStatus = getDeleteSmtpTokenRequestStatus;